import { render, staticRenderFns } from "./buttonCustomSwiper.vue?vue&type=template&id=30202d33&scoped=true&"
import script from "./buttonCustomSwiper.vue?vue&type=script&lang=js&"
export * from "./buttonCustomSwiper.vue?vue&type=script&lang=js&"
import style0 from "./buttonCustomSwiper.vue?vue&type=style&index=0&id=30202d33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30202d33",
  null
  
)

export default component.exports